var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"venta s-1"},[_c('p',{staticClass:"m-0"},[_c('strong',[_vm._v(_vm._s(_vm.producto.name))])]),_c('hr'),_c('p',[_vm._v(" Cantidad: "+_vm._s(_vm.producto.amount)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }